import "whatwg-fetch";
import "react";
import "react-dom";
import "react-router-dom";
if (!window._babelPolyfill) {
    require("babel-polyfill");
}
